import * as zod from 'zod';

import { type DepositTonValues } from './deposit-ton-form-values.model';

export const getDepositTonSchema = (): zod.ZodType<DepositTonValues> =>
  zod.object({
    amount: zod.coerce.number().gt(0, { message: 'Amount must be positive' }),
    // .gte(0.5, { message: 'Minimal withdraw amount is 0.5 TON' })
    // .max(parseFloat(balance ?? '0.0'), 'Insufficient funds'),
  });
